import { render } from "./PackageConfirmView.vue?vue&type=template&id=36785445&scoped=true"
import script from "./PackageConfirmView.vue?vue&type=script&lang=js"
export * from "./PackageConfirmView.vue?vue&type=script&lang=js"

import "./PackageConfirmView.vue?vue&type=style&index=0&id=36785445&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36785445"]])

export default __exports__